module.exports = __webpack_public_path__ + "static/media/applause.ff49caa6.mp3";